import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Reviews } from "@/components/Reviews";
import { Products } from "@/components/Products";
import { Estimator } from "@/components/Estimator";
import { Process } from "@/components/Process";
import { Gallery } from "@/components/Gallery";
import { ServiceArea } from "@/components/ServiceArea";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

export default function Home() {
  useLenis();
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Reviews />
      <Products />
      <Estimator />
      <Process />
      <Gallery />
      <ServiceArea />
      <Booking />
      <Footer />
    </main>
  );
}
